import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space } from 'styled-system';

const Background = styled.div`
  background: linear-gradient(180deg, rgba(129, 17, 21, 1) 0%, rgba(237, 28, 36, 1) 10px);

  ${space}
`;

const GradientSection = ({ children, ...props }) => {
  return <Background {...props}>{children}</Background>;
};

GradientSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GradientSection;
